import { LandingComponent } from './../../landing/landing.component';
import { Abstract } from './abstract';
import { Issue } from './issue';
import { JuvenileCase } from './../juvenile-case';
import { SafeJSON } from './../../shared/safe-json';


export class PreJaabstracts {
    private json: any;
    private key: string;
    private payoffCalculationsShowFlag: boolean[];

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
        const abstractParties: any[] = this.getAbstractPartiesList('A');  // Yes, code=’A’ is the debtor and code =’B’ is the creditor.
        if (abstractParties.length !== 0) {
            this.payoffCalculationsShowFlag = new Array((abstractParties.length)).fill(false);
            if (abstractParties.length === 1) {
                this.payoffCalculationsShowFlag[0] = true;  // only one debtor, show the calculations
            }
        } else {
            this.payoffCalculationsShowFlag = new Array((1)).fill(false);  // we need at least one flag set in the array
        }
    }
    getKey(): string {
        return this.key;
    }
    getPreJAAbstractNumber(): string {
        return SafeJSON.get('abstractNumber', this.json);
    }
    getAbstractJudgmentNumber(): string {
       return this.getPreJAAbstractNumber();
    }
    getPreJAJudgmentAmount(juvenileCase: JuvenileCase): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPreJAAbstractRef(juvenileCase: JuvenileCase, abstractRef: string): string {
        const prejJAIssueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = juvenileCase.getIssueListByKey(prejJAIssueRef);
        const issueAbstractRef = issue.getAbstractRefKey();
        if (issueAbstractRef === abstractRef) {
            return abstractRef;
        }
        return '';
    }
    // Wilson - 1997CR3038  preJA
    getPreJAInterestRate(juvenileCase: JuvenileCase): string {
        const rateString: string = (SafeJSON.get('judgmentSummary.interestRate', this.json)).toString();
        const rate = SafeJSON.getNumber('judgmentSummary.interestRate', this.json) * 100;
        if (rateString.length > 0) {
            return rate.toPrecision(rateString.length - 1);
        }
        return rateString;
    }
    getIsPreJAPartiallyAbstracted(): boolean {
        const code = SafeJSON.get('judgmentSummary.judgmentSummaryAbstractStatusCode.code', this.json);
        if (code === 'PART') {
            return true;
        }
        return false;
    }
    getIsPreJAFullyAbstracted(): boolean {
        const code = SafeJSON.get('judgmentSummary.judgmentSummaryAbstractStatusCode.code', this.json);
        if (code === 'FULL') {
            return true;
        }
        return false;
    }
    getPreJAAmountOwed(): Number {
        return SafeJSON.get('totalBalance', this.json);
    }
    getPreJAjudgmentTransactionList(juvenileCase: JuvenileCase, abstractRef: string): any[] {
        const judgmentTransactionList: any[] = SafeJSON.get('judgmentSummary.judgmentTransactionList', this.json);

        return judgmentTransactionList.sort( function(p1, p2) {
            const result = p1.effectiveDate.localeCompare(p2.effectiveDate);
            if (result !== 0) {
                return result;
            }
            // Dates are the same so look at the type (nested sort)
            return p1.transactionType.description.localeCompare(p2.transactionType.description);
        });
    }
    getPreJAAmount(transaction: string): Number {
        return SafeJSON.getNumber('amount', transaction);
    }
    getPreJAAmountInterest(transaction: string): Number {
        return SafeJSON.getNumber('amount', transaction) * 100;
    }
    getPreJAEffectiveDate(transaction: string): string {
        return SafeJSON.get('effectiveDate', transaction);
    }
    getPreJATransactionType(transaction: string): string {
        return SafeJSON.get('transactionType.description', transaction);
    }
    getPreJATransactionSource(transaction: string): string {
        return SafeJSON.get('source.description', transaction);
    }
    getPreJAReasonCode(transaction: string): string {
        return SafeJSON.get('cancelReason.description', transaction);
    }
    getPreJAReferenceNumber(transaction: string): string {
        return SafeJSON.get('referenceNumber', transaction);
    }
    getPreJAIssueClockedInDate(juvenileCase: JuvenileCase): string {
        const issueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = juvenileCase.getIssueListByKey(issueRef);
        const clockedDate = issue.getPleadingClockedInDate(juvenileCase);
        return clockedDate;
    }
    getPreJAPleadingTypeDescription(juvenileCase: JuvenileCase): string {
        const issueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = juvenileCase.getIssueListByKey(issueRef);
        const text = issue.getPleadingDescription(juvenileCase);
        return text;
    }
    getPreJAIssueType(juvenileCase: JuvenileCase): string {
        const issueRef = SafeJSON.get('issueRef', this.json);
        const issue: Issue = juvenileCase.getIssueListByKey(issueRef);
        const text = issue.getType();
        return text;
    }
    getPreJAAbstractStatus(): string {
        return SafeJSON.get('abstractStatus', this.json);
    }
    getPreJAClockedInOnDate(): string {
        return SafeJSON.get('clockDate', this.json);
    }
    getPreJAAbstractStatusDate(): string {
        return SafeJSON.get('cancelDate', this.json);
    }
    getPreJAAbstractCancelReasonCodeDescription(): string {
        let reason = SafeJSON.get('cancelReason.description', this.json);
        if (reason !== '') {
            reason = ', ' + reason;
        }
        return reason;
    }
    getPreJAPartialAbstract(juvenileCase: JuvenileCase): string {
        const SPECIALBOOKPAGE8S = '888';
        const SPECIALBOOKPAGE9S = '999';
        const seeClerkText = 'Please see clerk for complete details.';
        const orderList: any[] = juvenileCase.getOrderList();

        if (this.getIsPreJAPartiallyAbstracted()) {
            for (let i = 0; i < orderList.length; i++) {
                let issueKey = SafeJSON.get('issueKey', orderList[i].json);
                if (issueKey === this.json.issueRef) {

                    const docketBookNum = SafeJSON.get('docketBookNum', orderList[i].json);
                    const docketPageNum = SafeJSON.get('docketPageNum', orderList[i].json);
                    if (docketBookNum === '') {
                        return seeClerkText;
                    }
                    if (docketBookNum === SPECIALBOOKPAGE8S || docketBookNum === SPECIALBOOKPAGE9S) {
                        return seeClerkText;
                    }
                    return ' See book ' + docketBookNum + ', page ' + docketPageNum + '.';
                }
            }
        }
        return seeClerkText;
    }
    ////////////////////////////////////////////////////////////////////////////
    getPreJAPayoffCalculatorDailyInterestMessage(abstractParty: any): string {
        let dailyInterestAmount = this.getPreJAPayoffDailyInterest(abstractParty);
        const text = this.getPayoffCompoundInterestMessage(abstractParty);
        if (text !== '') {
            return text;
        }
        // if there are no interval interest rates, then just use the daily interest for the payoff.
        return 'Interest accrues at $' + dailyInterestAmount + ' per day.';
    }
    getPreJAShowPayoffInterestMessage(abstractParty: any): boolean {
        if (this.getPreJAPayoffDailyInterest(abstractParty) === null
            || this.getPreJAPayoffDailyInterest(abstractParty) === 0) {
            return false;
            }
        return true;
    }
    getPreJAPayoffDailyInterest(abstractParty: any): number {
        return SafeJSON.getNumber('dailyInterest', this.json);
    }
    // Ordered
    getPayoffCalculatorOrderedMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorOrderedInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('totalInterest', this.json);
    }
    getPayoffCalculatorOrderedTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('totalAmount', this.json);
    }
    // Paid
    getPayoffCalculatorPaidMoneyAward(abstractParty: any): number {
        let num: number = SafeJSON.getNumber('totalPrincipalPaid', this.json);
        return Abstract.convertToNegativeNumber(num);
    }
    getPayoffCalculatorPaidInterest(abstractParty: any): Number {
        return Abstract.convertToNegativeNumber(SafeJSON.getNumber('totalInterestPaid', this.json));
    }
    getPayoffCalculatorPaidCostsAndFees(abstractParty: any): Number {
        return Abstract.convertToNegativeNumber(SafeJSON.getNumber('totalCostPaid', this.json));
    }
    getPayoffCalculatorPaidTotal(abstractParty: any): Number {
        return Abstract.convertToNegativeNumber(SafeJSON.getNumber('totalPaid', this.json));
    }
    // Balance
    getPayoffCalculatorBalanceMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('principalBalance', this.json);
    }
    getPayoffCalculatorBalanceInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('interestBalance', this.json);
    }
    getPayoffCalculatorBalanceCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('costBalance', this.json);
    }
    getPayoffCalculatorBalanceTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('totalBalance', this.json);
    }
    getPayoffCalculatedDate(): string {
        return SafeJSON.get('payoffCalculatedOnDate', this.json);
    }
    getPayoffCalculatorMaxLiabiltyMoneyAward(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorMaxLiabiltyCostsAndFees(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorMaxLiabiltyInterest(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    getPayoffCalculatorMaxLiabiltyTotal(abstractParty: any): Number {
        return SafeJSON.getNumber('totalPrincipal', this.json);
    }
    returnIfNotEmpty(source: string, displayString: string): string {
        if (source === '' || source === '-') {
            return '';
        }
        return displayString;
    }
    showPreJAPayoffCalculation(i: number) {
        this.payoffCalculationsShowFlag[i] = true;
    }
    hidePreJAPayoffCalculation(i: number) {
        this.payoffCalculationsShowFlag[i] = false;
    }
    getPreJAPayoffCalculationsShowFlag(i: number): boolean {
        return this.payoffCalculationsShowFlag[i];
    }
    public getAffectedParty(juvenileCase: JuvenileCase, abstractParty: any): string {
        const casePartyRef = SafeJSON.getWithDefault('casePartyRef', abstractParty.json);
        const partyName = juvenileCase.getPartyNameByPartyRef(casePartyRef);
        const partyRole = juvenileCase.getPartyDescriptionByPartyRef(casePartyRef);
        const partyNumber = juvenileCase.getPartyNumberByPartyRef(casePartyRef);
        return partyName + ' (' + partyRole + ' ' + partyNumber + ')';
    }
    getAbstractParties(): any {
        return SafeJSON.get('issueOrderPartyRef', this.json);
    }
    getAbstractPartiesList(type: string): any[] {
        const abstractPartiesMap = this.getAbstractParties();
        const map = new Map();

        Object.keys(abstractPartiesMap).forEach(key => {
            const value = new Issue(abstractPartiesMap[key], key);
            map.set(key, value);
        });
        let abstractPartiesList: any[] = Array.from(map.values());
        abstractPartiesList = abstractPartiesList.filter(list2 => list2.json.issueOrderPartyRole.code === type);
        abstractPartiesList = abstractPartiesList.sort( function(p1, p2) {
            let cpr1Number = Number.parseInt(p1.json.casePartyRef.slice(1, p1.json.casePartyRef.length));
            let cpr2Number = Number.parseInt(p2.json.casePartyRef.slice(1, p2.json.casePartyRef.length));
            return cpr1Number - cpr2Number;
        });
        return abstractPartiesList;
    }
    getAfffectedPartyStatus(juvenileCase: JuvenileCase, abstractParty: any): string {
        const abstractPartyStatus = SafeJSON.getWithDefault('abstractPartyStatus.description', abstractParty.json);
        const abstractPartyStatusCode = SafeJSON.getWithDefault('abstractPartyStatus.code', abstractParty.json);
        const date = '';
        if (abstractPartyStatusCode === 'CNCL') {
            return 'CANCELLED';
        }
        if (abstractPartyStatusCode === 'VACT') {
            return 'VACATED';
        }
        return 'ACTIVE';
    }
    getMoneyDetailList(): any[] {
        const list = this.getListOrEmptyArray('abstractMoneyDetailsList');
        list.sort( function(p1, p2) {
            return p1.detailNumber.localeCompare(p2.detailNumber);
        });
        return list;
    }
    getPayoffCompoundInterestMessage(abstractParty: any): string {
        const moneyList: any[] = this.getMoneyDetailList();
        let simpleInterestRateCount = 0;
        let compoundInterestRatesCount = 0;
        let compoundInterestRate = 0;
        let savedCompoundInterestRate = -1;

        for (let i = 0; i < moneyList.length; i++) {

            const intervalList: any[]  = SafeJSON.get('intervalList', moneyList[i]);
            for (let j = 0; j < intervalList.length; j++) {
                const compoundInterestDescription = this.getSimpleCompoundIndicator(intervalList[j]);
                if (compoundInterestDescription === 'SIMPLE') {
                    simpleInterestRateCount++;
                }
                if (compoundInterestDescription === 'COMPOUND') {
                    compoundInterestRate = SafeJSON.getWithDefault('interestRate', intervalList[j]);
                    if (savedCompoundInterestRate === -1) {
                        savedCompoundInterestRate = compoundInterestRate;
                        compoundInterestRatesCount = 1;
                    } else {
                        if (savedCompoundInterestRate !== compoundInterestRate) {
                            compoundInterestRatesCount++;
                        }
                    }
                }
            }
        }
        // console.log('compoundInterestRateCount=' + compoundInterestRatesCount + ',
        // simpleInterestRateCount=' + simpleInterestRateCount);
        if (compoundInterestRatesCount === 1 && simpleInterestRateCount === 0) {
            compoundInterestRate = compoundInterestRate * 100;
            return 'Interest accrues at ' + compoundInterestRate  + '% compounded daily.';
        }
        if (compoundInterestRatesCount > 0) {
            return 'See clerk for interest calculation.';
        }
        return '';
    }
    getSimpleCompoundIndicator(interval: any): string {
        return SafeJSON.getWithDefault('simpleCompoundIndicator.description', interval);
    }
    getAfffectedPartyCancelDateIfPresent(juvenileCase: JuvenileCase, abstractParty: any): string {
        const abstractPartyStatus = SafeJSON.getWithDefault('abstractPartyStatus', abstractParty.json);
        let date = '';
        if (abstractPartyStatus.code === 'CNCL') {
            date = SafeJSON.get('cancelDate', abstractParty.json);
        }
        if (abstractPartyStatus.code === 'VACT') {
            date = SafeJSON.get('vacatedDate', abstractParty.json);
        }
        return date;
    }
    /////////////////////////////////////////////////////////////////////////
    getListOrEmptyArray(id: string): any[] {
        const list = SafeJSON.get(id, this.json);
        if (list === '') {
            return [{}];
        }
        return Array.from(list.values());
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/pre-jaabstracts.ts